export default {
	 resetFilter ({commit}) {
		commit('RESET_FILTER_STATE')

		return this.dispatch('CREDIT_CARDS_MODULE/index/getCreditCards')
	}
}